(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video_carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mp4-theme-carousel')) {
    customElements.define('mp4-theme-carousel', class extends HTMLElement {
      thumbnailSeconds(value) {
        if (!/^\d+(?::[0-5]\d){0,2}(?:\.\d+)?$/.test(value)) return null;
        const seconds = value.split(':').reduce((total, part) => total * 60 + Number(part), 0);
        return Number.isFinite(seconds) ? seconds : null;
      }

      connectedCallback() {
        this.controller?.abort();
        this.warmup?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const viewport = this.querySelector('.mp4-carousel__viewport');
        const videos = this.querySelectorAll('video');
        const warm = (video) => { video.preload = 'auto'; };
        if (typeof IntersectionObserver !== 'undefined') {
          this.warmup = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              warm(entry.target);
              this.warmup.unobserve(entry.target);
            });
          }, { rootMargin: '200px 0px', threshold: 0.01 });
        }

        videos.forEach((video, index) => {
          const card = video.closest('.mp4-carousel__card');
          const button = card.querySelector('.mp4-carousel__toggle');
          button.dataset.number = index + 1;
          const thumbnailTime = this.thumbnailSeconds(card.dataset.thumbnailTime || '');
          let started = video.dataset.started === 'true';
          let thumbnailSeeking = false;
          let thumbnailCaptured = false;
          let thumbnail = card.querySelector('.mp4-carousel__thumbnail');
          let requested = !video.paused;
          let attempt = 0;
          let loadingTimer;
          const sources = Array.from(video.querySelectorAll('source'));
          const failedSources = new Set();
          const setState = (state) => {
            if (state !== 'loading') {
              clearTimeout(loadingTimer);
              loadingTimer = null;
            } else if (!loadingTimer) {
              loadingTimer = setTimeout(() => {
                requested = false;
                attempt++;
                video.pause();
                setState('error');
              }, 15000);
            }
            card.dataset.state = state;
            card.classList.toggle('is-playing', state === 'playing');
            card.classList.toggle('is-loading', state === 'loading');
            card.classList.toggle('has-error', state === 'error');
            button.setAttribute('aria-busy', String(state === 'loading'));
            const action = { loading: 'Cancel loading', playing: 'Pause', error: 'Retry playing', paused: 'Play' }[state];
            button.setAttribute('aria-label', `${action} video ${button.dataset.number}`);
          };
          options.signal.addEventListener('abort', () => clearTimeout(loadingTimer), { once: true });
          sources.forEach((source) => source.addEventListener('error', () => {
            failedSources.add(source);
            if (failedSources.size !== sources.length) return;
            requested = false;
            attempt++;
            video.pause();
            setState('error');
          }, options));
          const showThumbnail = () => {
            if (started || thumbnailTime === null || !Number.isFinite(video.duration) || video.duration <= 0) return;
            const time = Math.min(Math.max(thumbnailTime, 0.001), Math.max(0, video.duration - 0.05));
            try {
              thumbnailSeeking = true;
              video.currentTime = time;
            } catch {
              // Keep the original cover if this media source cannot seek.
            }
          };
          video.addEventListener('seeked', () => {
            if (started || !thumbnailSeeking) return;
            thumbnailSeeking = false;
            try {
              if (!video.videoWidth || video.readyState < 2) throw new Error('Frame unavailable');
              const canvas = document.createElement('canvas');
              canvas.className = 'mp4-carousel__thumbnail';
              canvas.setAttribute('aria-hidden', 'true');
              canvas.width = Math.min(720, video.videoWidth);
              canvas.height = Math.round(canvas.width * video.videoHeight / video.videoWidth);
              // Display the frame without reading/exporting pixels, including cross-origin MP4s.
              canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
              thumbnail?.remove();
              button.parentElement.insertBefore(canvas, button);
              thumbnail = canvas;
              thumbnailCaptured = true;
              // Buffer the beginning now, instead of seeking back only after the click.
              video.currentTime = 0;
            } catch {
              // Fall back to the paused video frame when canvas capture is unavailable.
              video.removeAttribute('poster');
            }
          }, options);
          video.addEventListener('loadedmetadata', showThumbnail, options);
          if (video.readyState >= 1) showThumbnail();
          button.addEventListener('click', async () => {
            if (requested) {
              requested = false;
              attempt++;
              video.pause();
              setState('paused');
              return;
            }
            const currentAttempt = ++attempt;
            requested = true;
            setState('loading');
            try {
              const resetToStart = !started && thumbnailTime !== null && !thumbnailCaptured;
              started = true;
              warm(video);
              if (video.error || video.networkState === 3 || failedSources.size === sources.length && sources.length > 0) {
                failedSources.clear();
                video.load();
              }
              if (resetToStart && video.readyState >= 1) video.currentTime = 0;
              await video.play();
            } catch {
              if (currentAttempt !== attempt || !requested) return;
              requested = false;
              setState('error');
            }
          }, options);
          video.addEventListener('play', () => {
            started = true;
            video.dataset.started = 'true';
            requested = true;
            videos.forEach((other) => { if (other !== video) other.pause(); });
            setState('loading');
          }, options);
          video.addEventListener('playing', () => {
            if (!requested) return;
            thumbnail?.remove();
            thumbnail = null;
            setState('playing');
          }, options);
          ['waiting', 'seeking'].forEach((event) => video.addEventListener(event, () => {
            if (requested) setState('loading');
          }, options));
          ['pause', 'ended', 'error'].forEach((event) => video.addEventListener(event, () => {
            requested = false;
            attempt++;
            setState(event === 'error' ? 'error' : 'paused');
          }, options));
          setState(requested ? 'loading' : 'paused');
          if (this.warmup) this.warmup.observe(video);
          else warm(video);
        });

        this.querySelectorAll('[data-direction]').forEach((button) => {
          button.addEventListener('click', () => {
            const card = viewport.querySelector('.mp4-carousel__card:not([hidden])');
            if (!card) return;
            const gap = parseFloat(getComputedStyle(viewport).gap) || 0;
            const direction = button.dataset.direction === 'next' ? 1 : -1;
            const rtl = getComputedStyle(viewport).direction === 'rtl' ? -1 : 1;
            viewport.scrollBy({
              left: (card.getBoundingClientRect().width + gap) * direction * rtl,
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
            });
          }, options);
        });

        this.addEventListener('shopify:block:select', (event) => {
          event.target.closest('.mp4-carousel__card')?.scrollIntoView({
            behavior: 'instant', block: 'nearest', inline: 'nearest'
          });
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.warmup?.disconnect();
        this.querySelectorAll('video').forEach((video) => video.pause());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
